import axios from 'axios';


const USER_ENDPOINT = '/api/v1/user/';
const EDUCATOR_ENDPOINT = '/api/v1/educator/';
const STUDENT_ENDPOINT = '/api/v1/student/';
const PROFESSIONAL_ENDPOINT = '/api/v1/professional/';

export async function getUserById(userId) {
  const response = await axios.get(`${USER_ENDPOINT}${userId}`);
  return response.data;
}

export async function createEducator(userData) {
  const response = await axios.post(`${EDUCATOR_ENDPOINT}signup/`, userData);
  return response.data;
}
export async function validateEmail(data) {
  const response = await axios.post(`${EDUCATOR_ENDPOINT}validate-email/`, data);
  return response;
}

export async function createStudent(userData) {
  const response = await axios.post(`${STUDENT_ENDPOINT}signup/`, userData);
  return response.data;
}

export async function getSchools(q) {
  const response = await axios.get(`/schools/list/?q=${q}`);
  return response.data;
}

export async function getGroups(q) {
  const response = await axios.get(`/groups/list/?q=${q}`);
  return response.data;
}

export async function createSchoolMembership(userData) {
  const response = await axios.post(`${EDUCATOR_ENDPOINT}school/membership/`, userData);
  return response.data;
}

export async function createGroupMembership(userData) {
  const response = await axios.post(`${EDUCATOR_ENDPOINT}group/membership/`, userData);
  return response.data;
}

export async function createProfessional(userData) {
  const response = await axios.post(`${PROFESSIONAL_ENDPOINT}signup/`, userData);
  return response.data;
}

export async function getTopics(q) {
  const response = await axios.get(`/topics/?q=${q}`);
  return response.data;
}

export async function getTopicMatchStrength(data) {
  const response = await axios.post('/topics-match-strength/', { topics: data });
  return response.data;
}

export async function addTopics(data) {
  const response = await axios.post('/add-topics/', { topics: data });
  return response.data;
}

export async function getCompanyBySlug(companySlug) {
  const response = await axios.get(`/api/v1/companies/${companySlug}/`);
  return response.data;
}

export async function getCompanies(q) {
  const response = await axios.get(`/api/v1/companies?q=${encodeURIComponent(q)}`);
  return response.data;
}

export async function getCompanyCustomField(companyId) {
  const response = await axios.get(`/api/v1/linkedincompany-custom-fields/${companyId}/`);
  return response.data;
}

export async function getCorporatePartner(corporatePartnerSlug) {
  const response = await axios.get(`/api/v1/corporate-partners/${corporatePartnerSlug}/`);
  return response.data;
}

export async function generatePhotoSignature(url, paramsToSign) {
  return axios.post(url, paramsToSign);
}

export async function setProfessionalProfilePicture(url, data) {
  const response = await axios.post(url, data);
  return response.data;
}

export async function getAnswerEndorsements(answerId) {
  return axios.get(`/api/v1/endorse-answer/${answerId}/`);
}

export async function createAnswerEndorsements(data) {
  return axios.post('/api/v1/endorse-answer/', data);
}

